// extracted by mini-css-extract-plugin
module.exports = {"tag":"_9e1425b4d3--tag--JZjEJ","tag_close":"_9e1425b4d3--tag_close--cl62d"};